

// Tools namespace
(izele.tools = function (tools, $, undefined) {

    tools.createExpandingTextarea = function (textarea, minHeight, maxHeight) {
        // todo: replaced by importable function in tools/general - replace uses of this one
        // set default heights if not provided
        minHeight = typeof minHeight !== 'undefined' ? minHeight : 28;
        maxHeight = typeof maxHeight !== 'undefined' ? maxHeight : 500;

        textarea.oninput = function() {
            this.updateHeight();
        };

        textarea.updateHeight = function () {
            this.style.height = "";
            this.style.height = Math.max(Math.min(textarea.scrollHeight, maxHeight), minHeight) + "px";
        };

    };

    /** Get the suffix from a filename string */
    tools.getFileSuffix = function (filename) {
        // todo: replaced by importable function in tools/general - replace uses of this one
        // https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/12900504#12900504
        return filename.substr((~-filename.lastIndexOf(".") >>> 0) + 2);
    };

    tools.createModal = function self(options) {
        // modified from http://www.ovais.me/javascript/bootstrap-3-modal-easy-way/
        // todo: replace usage with new Vue modal
        options = $.extend({
            title: '',
            body: '',
            footer: '',
            remote: false,
            backdrop: 'static',
            size: false,
            onShow: false,
            onHide: false,
            actions: false
        }, options);

        self.onShow = typeof options.onShow === 'function' ? options.onShow : function () {};
        self.onHide = typeof options.onHide === 'function' ? options.onHide : function () {};

        if (self.$modal === undefined) {
            self.$modal = $('<div class="modal fade"><div class="modal-dialog"><div class="modal-content"></div></div></div>').appendTo('body');
            self.$modal.on('shown.bs.modal', function (e) {
                self.onShow.call(this, e);
            });
            self.$modal.on('hidden.bs.modal', function (e) {
                self.onHide.call(this, e);
            });
        }

        var modalClass = {
            small : "modal-sm",
            large : "modal-lg"
        };

        var modalBody = '<div class="modal-body">' + options.body + '</div>';

        var modalHeader = '';
        if (options.title !== '') {
            modalHeader =
                '<div class="modal-header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="font-size: 150%">&times;</span></button>' +
                    '<h4 class="modal-title">' + options.title + '</h4>' +
                '</div>';

        } else {
            modalBody += '<button type="button" class="close close-modal-abs" data-dismiss="modal" aria-label="Close" style="z-index: 9999"><span aria-hidden="true" style="font-size: 150%">&times;</span></button>';
        }

        var modalFooter = '';
        if (options.footer !== '') {
            modalFooter = '<div class="modal-footer"></div>';
        }

        self.$modal.data('bs.modal', false);
        self.$modal.find('.modal-dialog').removeClass().addClass('modal-dialog ' + (modalClass[options.size] || ''));
        self.$modal.find('.modal-content').html(modalHeader + modalBody + modalFooter);

        self.$modal.modal(options);

        return self.$modal;
    };

    /** Regex for matching valid web URLs: https://gist.github.com/dperini/729294 added 20170204 */
    // todo: replace with isUri??
    tools.webUrlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    /** Format the standard jquery xhr response into a human readable string */
    tools.formatXHRResponse = function (xhr, method) {
        var errorMessage = "";
        var method_lookup = {
            'POST': gettext("adding the record"),
            'PATCH': gettext("making your changes"),
            'DELETE': gettext("deleting the record"),
            'GET': gettext("getting the data"),
            undefined: ""
        };

        if ('responseJSON' in xhr) {
            if (xhr.responseJSON instanceof Object) {
                var errors = $.map(xhr.responseJSON, function(value, index) {
                    return [value];
                });
                errorMessage = gettext("Error(s):") + " " + errors.join(', ');

            } else {
                errorMessage = gettext("Error(s):") + " " + xhr.responseJSON;
            }

        } else {
            errorMessage = gettext("There was an error") + " " + method_lookup[method] + " (" + xhr.status + ": " + xhr.statusText + ")";
        }

        return errorMessage
    };

    // todo: replaced with importable function in tools/network - update references and remove this
    /** parseUri 1.2.2 (c) Steven Levithan <stevenlevithan.com> MIT License */
    tools.parseUri = function(str) {
        var	o   = tools.parseUri.options,
            m   = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
            uri = {},
            i   = 14;

        while (i--) uri[o.key[i]] = m[i] || "";

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    };

    tools.parseUri.options = {
        strictMode: false,
        key: ["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],
        q:   {
            name:   "queryKey",
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };

    // todo: replaced with importable function in tools/network - update references and remove this
    tools.queryStringToObject = function(str) {
        // https://stackoverflow.com/a/8649003/1318569
        try {
            return JSON.parse('{"' + str.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
                return key === "" ? value : decodeURIComponent(value)
            });

        } catch(error) {
            return {};
        }

    };

    // todo: now in validation.js, remove this and old references
    tools.isEmailAddress = function (str) {
        // from https://github.com/jquery-validation/jquery-validation/blob/master/src/core.js
        return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(str);
    };

})(izele.tools = izele.tools || {}, jQuery);


// todo: replace instances of this with lodash debounce
/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010 - http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * Copyright (c) 2010 "Cowboy" Ben Alman - Dual licensed under the MIT and GPL licenses. http://benalman.com/about/license/
 * Modified to fit in the izele namespace, rather than jquery
 */
(function(window, undefined){
    '$:nomunge'; // Used by YUI compressor.

    // push it into the izele tools namespace
    var db = izele.tools, jq_throttle;

    db.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
        var timeout_id,
        last_exec = 0;

        if ( typeof no_trailing !== 'boolean' ) {
            debounce_mode = callback;
            callback = no_trailing;
            no_trailing = undefined;
        }

        function wrapper() {
            var that = this,
            elapsed = +new Date() - last_exec,
            args = arguments;

            function exec() {
                last_exec = +new Date();
                callback.apply( that, args );
            }

            function clear() {
                timeout_id = undefined;
            }

            if ( debounce_mode && !timeout_id ) {
                exec();
            }

            timeout_id && clearTimeout( timeout_id );

            if ( debounce_mode === undefined && elapsed > delay ) {
                exec();

            } else if ( no_trailing !== true ) {
                timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
            }
        }

        if ( db.guid ) {
            wrapper.guid = callback.guid = callback.guid || $.guid++;
        }

        return wrapper;
    };

    db.debounce = function( delay, at_begin, callback ) {
        return callback === undefined ? jq_throttle( delay, at_begin, false ) : jq_throttle( delay, callback, at_begin !== false );
    };

})(this);